const hofData = [
  // NEW 2026
  {
    year: '2026',
    content: (
      <>
        <div className='famer'>
          <h2>Olivia Chen</h2>
          <div>
            <p>
              1st place – Crescendo International Competition (Carnegie Hall, NY)
            </p>
            <p>
              1st place – Young Artist Piano Competition (Westfield State University, MA)
            </p>
            <p>2nd place – Judged Festival (Salem State University)</p>
          </div>
        </div>
        <div className='famer'>
          <h2>Anastasia Baidalo</h2>
          <div>
            <p>1st place – Crescendo International Music Competition (Carnegie Hall, NY)

            </p>
            <p>2nd place – Miclot International Music Competition

            </p>
          </div>
        </div>
        <div className='famer'>
          <h2>Eleanor Parker

          </h2>
          <div>
            <p>1st place – Crescendo International Competition (Carnegie Hall, NY)

            </p>
            <p>3rd place – Miclot International Competition

            </p>

          </div>
        </div>
        <div className='famer'>
          <h2>Gabriella Solari</h2>
          <div>
            <p>1st place – Crescendo International Music Competition

            </p>

          </div>
        </div>
        <div className='famer'>
          <h2>Isabella Solari

          </h2>
          <p>
            1st place – Crescendo International Music Competition


          </p>
        </div>
        <div className='famer'>
          <h2>Billy Solari</h2>

          <p>
            1st place – Crescendo International Music Competition
          </p>
        </div>
        <div className='famer'>
          <h2>Keira Bedretdinov

          </h2>
          <div>
            <p>1st place – Crescendo International Competition (Harvard University, MA)

            </p>

          </div>
        </div>
        <div className='famer'>
          <h2>Benjamin Tatashin
          </h2>
          <div>
            <p>
              1st place – Crescendo International Competition (Carnegie Hall, NY)
            </p>

          </div>
        </div>
        <div className='famer'>
          <h2>Michael Tatashin

          </h2>
          {/* NEW */}
          <div>
            <p>1st place – Little Mozart International Competition (Harvard University, MA)

            </p>

          </div>
        </div>
        <div className='famer'>
          <h2>Aarav Shroff</h2>
          {/* NEW */}
          <div>
            <p>
              Honorable Mention – American Protégé (NY, Carnegie Hall)
            </p>

          </div>
        </div>
        <div className='famer'>
          <h2>Kristina Pan</h2>
          <p>2nd place – Miclot International Music Competition

          </p>
        </div>
        <div className='famer'>
          <h2>Alice Wang</h2>
          {/* NEW */}
          <div>
            <p>RCM, Music Theory, Level 8 – First Class Honours with Distinction

            </p>

          </div>
        </div>



      </>
    ),
  },
  // end 2026
  {
    year: '2025',
    content: (
      <>
        <div className='famer'>
          <h2>Daniel Kan</h2>
          <div>
            <p>
              1st place – Young Artist Piano Competition (Westfield State
              University, MA)
            </p>
            <p>
              2nd place – Elite International Music Competition (Carnegie Hall,
              NY)
            </p>
            <p>2nd place – NYC Miclot International Music Competition (NY)</p>
          </div>
        </div>
        <div className='famer'>
          <h2>Gabriella Solari</h2>
          {/* NEW */}
          <div>
            <p>1st place (solo) – Little Mozarts International Competitions</p>
            <p>1st place (duet) – Little Mozarts International Competitions</p>
            <p>2nd place (solo) – Elite International Music Competition (NY)</p>
          </div>
        </div>
        <div className='famer'>
          <h2>Isabella Solari</h2>
          {/* NEW */}
          <div>
            <p>1st place (solo) – Little Mozarts International Competitions</p>
            <p>1st place (duet) – Little Mozarts International Competitions</p>
            <p>3rd place (solo) – Elite International Music Competition (NY)</p>
            <p>
              Honorable mention – Judged Festival (Salem State University, MA)
            </p>
          </div>
        </div>
        <div className='famer'>
          <h2>Billy Solari</h2>
          {/* NEW */}
          <div>
            <p>1st place – Judged Festival (Salem State University, MA)</p>
            <p>1st place – Little Mozarts International Competitions</p>
            <p>2nd place – Elite International Music Competition (NY)</p>
          </div>
        </div>
        <div className='famer'>
          <h2>Ethan Zhao</h2>
          {/* NEW */}
          <p>
            1st place – Young Artist Piano Competition (Westfield State
            University, MA)
          </p>
        </div>
        <div className='famer'>
          <h2>Emma Zhao</h2>
          {/* NEW */}
          <p>
            2nd place – Young Artist Piano Competition (Westfield State
            University, MA)
          </p>
        </div>
        <div className='famer'>
          <h2>Olivia Chen</h2>
          <div>
            <p>1st place – Winter Serenade Competition (Sempre Music, MA)</p>
            <p>
              1st place – Young Artist Piano Competition (Westfield State
              University, MA)
            </p>
          </div>
        </div>
        <div className='famer'>
          <h2>Keira Bedretdinov</h2>
          <div>
            <p>
              1st place – Elite International Music Competition (Carnegie Hall,
              NY)
            </p>
            <p>1st place – Little Mozarts International Competitions</p>
            <p>
              3rd place – Young Artist Piano Competition (Westfield State
              University, MA)
            </p>
          </div>
        </div>
        <div className='famer'>
          <h2>Aarav Shroff</h2>
          {/* NEW */}
          <div>
            <p>1st place – NYC Miclot International Music Competition (NY)</p>
            <p>1st place – Little Mozarts International Competitions</p>
            <p>2nd place – Winter Serenade Competition (Sempre Music, MA)</p>
            <p>
              2nd place – Elite International Music Competition (Carnegie Hall,
              NY)
            </p>
            <p>
              2nd place – Young Artist Piano Competition (Westfield State
              University, MA)
            </p>
          </div>
        </div>
        <div className='famer'>
          <h2>Kristina Pan</h2>
          {/* NEW */}
          <div>
            <p>
              1st place – Young Artist Piano Competition (Westfield State
              University, MA)
            </p>
            <p>3rd place – Judged Festival (Salem State University, MA)</p>
          </div>
        </div>
        <div className='famer'>
          <h2>Gemma Cohen</h2>
          <p>1st place – Little Mozarts International Competitions</p>
        </div>
        <div className='famer'>
          <h2>Anastasia Baidalo</h2>
          <p>2nd place – Performance Competition (Manchester, NH)</p>
        </div>
        <div className='famer'>
          <h2>Alice Wang</h2>
          {/* NEW */}
          <div>
            <p>2nd place – Judged Festival (Salem State University, MA)</p>
            <p>
              Honorable mention – XVI Chopin Piano Competition (Hartford, CT)
            </p>
            <p>RCM (exam) – Grade 9 (Canada)</p>
          </div>
        </div>
        <div className='famer'>
          <h2>Angelina Wang</h2>
          {/* NEW */}
          <div>
            <p>
              Honorable mention – XVI Chopin Piano Competition (Hartford, CT)
            </p>
            <p>RCM (exam) – Grade 9, RCM First Class Honor Roll (Canada)</p>
          </div>
        </div>
        <div className='famer'>
          <h2>Nicholas Drachev</h2>
          <p>1st place – Little Mozarts International Competitions</p>
        </div>
        <div className='famer'>
          <h2>Benjamin Tatashin</h2>
          <p>3rd place – Little Mozarts International Competitions</p>
        </div>
        <div className='famer'>
          <h2>Michael Tatashin</h2>
          <p>3rd place – Little Mozarts International Competitions</p>
        </div>
      </>
    ),
  },
  {
    year: 2024,
    content: (
      <>
        <div className='famer'>
          <h2>Alice Wang</h2>
          <div>
            <p>
              1st Place – International Concerto Competition (Sempre Musick)
            </p>
            <p>
              1st Place – Performance Competition (Manchester Community Music
              School)
            </p>
          </div>
        </div>
        <div className='famer'>
          <h2>Angelina Wang</h2>
          <div>
            <p>1st Place – International Concerto Competition (Sempre Music)</p>
            <p>
              2nd Place – Performance Competition (Manchester Community Music
              School)
            </p>
            <p>2nd Place – Judged Festival (Salem State University)</p>
          </div>
        </div>
        <div className='famer'>
          <h2>Ethan Zhao</h2>
          <div>
            <p>
              1st Place – Performance Competition (Manchester Community Music
              School)
            </p>
            <p>
              2nd Place – Elite International Music Competition (Carnegie Hall,
              NY)
            </p>
            <p>Honorable Mention – Judged Festival (Salem State University)</p>
          </div>
        </div>
        <div className='famer'>
          <h2>Emma Zhao</h2>
          <div>
            <p>
              1st Place – Elite International Music Competition (Carnegie Hall,
              NY)
            </p>
            <p>
              Honorable Mention – Performance Competition (Manchester Community
              Music School)
            </p>
            <p>Honorable Mention – Judged Festival (Salem State University)</p>
          </div>
        </div>
        <div className='famer'>
          <h2>Kristina Pan</h2>
          <div>
            <p>
              2nd Place – International Concerto Competition (Sempre Musick)
            </p>
            <p>Honorable Mention – Judged Festival (Salem State University)</p>
          </div>
        </div>
        <div className='famer'>
          <h2>Wendy Huang</h2>
          <div>
            <p>
              1st Place – Elite International Music Competition (Carnegie Hall,
              NY)
            </p>
            <p>
              1st Place – International Concerto Competition (Semite Musick)
            </p>
            <p>1st Place – Judged Festival (Salem State University)</p>
          </div>
        </div>
        <div className='famer'>
          <h2>Isabella Solari</h2>
          <div>
            <p>
              1st Place – Young Artist Piano Competition (Westfield State
              University)
            </p>
            <p>
              1st Place – International Concerto Competition (Sempre Musick)
            </p>
          </div>
        </div>
        <div className='famer'>
          <h2>Gabriella Solari</h2>
          <div>
            <p>
              1st Place – Young Artist Piano Competition (Westfield State
              University)
            </p>
            <p>2nd Place – International Concerto Competition (SempreMusick)</p>
          </div>
        </div>
        <div className='famer'>
          <h2>Billy Solari</h2>
          <div>
            <p>
              1st Place – Elite International Music Competition (Carnegie Hall,
              NY)
            </p>
            <p>
              1st Place – Young Artist Piano Competition (Westfield State
              University)
            </p>
            <p>
              2nd Place – International Concerto Competition (Sempre Musick)
            </p>
          </div>
        </div>
        <div className='famer'>
          <h2>Aarav Shroff</h2>
          <p>2nd Place – International Concerto Competition (Sempre Musick)</p>
        </div>
        <div className='famer'>
          <h2>Vincent Vinci</h2>
          <p>3rd Place – International Concerto Competition (Sempre Musick)</p>
        </div>
      </>
    ),
  },
  // contentArray: [
  //   {
  //     name: `Alice Wang`,
  //     honors: 'testing',
  //   },
  // ],
  // },
]

export default hofData
